import { ref, onMounted, onUnmounted } from "vue";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
    install: (app) => {
        app.mixin({
            setup() {
                const isAuthenticated = ref(false);
                const lastActivityTime = ref(Date.now());
                let refreshInterval;

                const store = useStore();
                const router = useRouter();

                const updateLastActivityTime = () => {
                    lastActivityTime.value = Date.now();
                };

                const checkSession = async () => {
                    try {
                        const token = store.state.auth.token;
                        if (token) {
                            isAuthenticated.value = true;
                            await refreshSession();
                        } else {
                            isAuthenticated.value = false;
                        }
                    } catch (error) {
                        console.error('Error checking session:', error);
                        isAuthenticated.value = false;
                    }
                };

                const logout = async () => {
                    try {
                        await store.dispatch('auth/logout');
                        router.push({ name: 'login' });
                    } catch (error) {
                        console.error('Error logging out:', error);
                    }
                };

                const refreshSession = async () => {
                    try {
                        await store.dispatch('auth/refreshSession');
                    } catch (error) {
                        console.error('Error refreshing session:', error);
                    }
                };

                const startSessionChecker = () => {
                    refreshInterval = setInterval(async () => {
                        const idleTime = Date.now() - lastActivityTime.value;
                        const currentTime = new Date().getTime();
                        const token = store.state.auth.token;

                        if (isAuthenticated.value && idleTime >= 120 * 60 * 1000) {
                            await logout();
                        }

                        if (token && currentTime - lastActivityTime.value >= 60 * 60 * 1000) {
                            await refreshSession();
                        }
                    }, 60000);
                };

                const stopSessionChecker = () => {
                    clearInterval(refreshInterval);
                };

                onMounted(async () => {
                    document.addEventListener('mousemove', updateLastActivityTime);
                    document.addEventListener('keydown', updateLastActivityTime);
                    await checkSession(); // Ensure checkSession is completed before starting the session checker
                    startSessionChecker();
                });

                onUnmounted(() => {
                    document.removeEventListener('mousemove', updateLastActivityTime);
                    document.removeEventListener('keydown', updateLastActivityTime);
                    stopSessionChecker();
                });

                return {}; // Return empty object as setup function requires a return
            }
        });
    }
};
